import React from "react";
import {Typography, Paper, Breadcrumbs, Link} from "@material-ui/core";
import { useTranslation } from "../../langs/useTranslation";
import { BreadCrumbs } from "../../components/device/BreadCrumbs";
import useStyles from "../../styles/groupsStyle";
// import "../../css/userList.scss"

import Category from "./Category";
import GroupUsersProvider from "./Provider";
import UsersList from "./UsersList";
import MenuList from '@/components/layout/Menu';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import {HomeOutlined} from '@material-ui/icons';
import {makeStyles} from '@material-ui/core/styles';
import {useGlobalState} from '@/GlobalProvider';
import { Resizable } from "re-resizable";
const drawerWidth = 240;
const footHeight = 64;

// const useStyles = makeStyles(theme => ({
//   root: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     flexDirection: "row",
//     height: `calc( 100vh - ${footHeight}px)`,
//     // paddingTop: theme.spacing(8),
//   },
//   drawer: {
//     width: "240px"
//   },
//   content: {
//     flex: 1,
//     boxSizing: "border-box",
//     padding: theme.spacing(2),
//     // marginLeft: drawerWidth,
//     height: "100%",
//     overflow: 'hidden',
//     display: 'flex',
//     flexDirection: 'column'
//   },
//   groupWrapper: {
//     display: "flex",
//     flex: 1,
//     width: "100%",
//     height: "100%",
//     minWidth: 0,
//     minHeight: 0
//   },
//   groupList: {
//     display: "flex",
//     flexDirection: "column",
//     marginRight: 24,
//     // maxHeight: 1249,
//     overflowX: "hidden",
//     overflowY: "auto",
//     flex: "none",
//     height: "100%",
//     width: "300px"
//   },
//   userList: {
//     flex: 1,
//     display: 'flex'
//   },
//   titleSection: {
//     marginBottom: "16px"
//   },
//   sizableGroupWrapper: {
//     height: "100% !important",
//     marginRight: 20,
//     flex: "none",
//     overflow: "hidden"
//   },
//   sizableGroupList: {
//     display: "flex",
//     flexDirection: "column",
//     width: "100%",
//     height: "100%",
//     overflowX: "hidden",
//     overflowY: "auto"
//   },
//   sizablePaper: {
//     height: "100%"
//   }
// }))

const GroupsUsers = () => {
  const { t } = useTranslation("groupUser");
  const classes = useStyles();
  const { menuFixedOpen } = useGlobalState()
  return (
      <>
        <Breadcrumbs aria-label="breadcrumb" separator={<NavigateNextIcon fontSize="small" />}>
          <Link color="inherit" href="/">
            <HomeOutlined />
            {t({ defaultMessage: "首页" })}
          </Link>
          <Typography color="textPrimary">
            {t({defaultMessage: "账号管理"})}
          </Typography>
        </Breadcrumbs>
        <div className={classes.titleWithSelect}>
          <Typography variant="h4">{t({defaultMessage: "账号管理"})}</Typography>
        </div>
        {/*<div className={classes.titleSection}>*/}
        {/*  <Typography variant="h4" style={{'fontWeight': 100}}>{t("section_title")}</Typography>*/}
        {/*  /!*<Typography variant="body1">*!/*/}
        {/*  /!*  {t("用户管理相关的列表")}*!/*/}
        {/*  /!*</Typography>*!/*/}
        {/*</div>*/}
        <div className={classes.groupWrapper}>
          <GroupUsersProvider>
            <Resizable
              defaultSize={{
                minWidth: 250,
                width: 300
              }}
              enable={{
                top: false,
                right: true,
                bottom: false,
                left: false,
                topRight: false,
                bottomRight: false,
                bottomLeft: false,
                topLeft: false
              }}
              className={classes.sizableGroupWrapper}
            >
              <Paper elevation={0} className={classes.groupList + " "+ classes.sizableGroupList}>
                <Category />
              </Paper>
            </Resizable>
            <UsersList />
          </GroupUsersProvider>
        </div>
      </>
  );
};

export default GroupsUsers;
